var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShield = function SvgIconShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.263 4.013A1.75 1.75 0 0 1 4.5 3.5h15a1.75 1.75 0 0 1 1.75 1.75v5.503c0 8.562-7.27 11.395-8.688 11.867-.364.13-.76.13-1.124 0-1.418-.472-8.688-3.305-8.688-11.867V5.25c0-.464.184-.91.513-1.237M4.75 5.5v5.253c0 7.022 5.82 9.455 7.25 9.946 1.43-.49 7.25-2.924 7.25-9.946V5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconShield;